"use client";

import { type ReactNode } from "react";
import { useSectionTheme } from "@/hooks/use-section-theme";

export default function MainWrapper({ children }: { children: ReactNode }) {
  const { theme } = useSectionTheme();

  return (
    <div
      className="relative flex min-h-screen w-full flex-col items-center justify-start overflow-hidden transition-colors duration-500"
      // style={{
      //   background: theme
      //     ? `linear-gradient(180deg, ${theme.gradientStart}40 0%, #0a0a0b 100%)`
      //     : "linear-gradient(180deg, #1a1a1c 0%, #0a0a0b 100%)",
      // }}
    >
      {/* <AnimatePresence mode="wait">
        <motion.div
          key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.4,
            ease: [0.25, 0.1, 0.25, 1],
          }}
          className="fixed left-0 top-0 z-0 size-full"
          style={{
            background: "linear-gradient(180deg, #2a2a3e 0%, #1f1f2e 100%)",
          }}
        />
      </AnimatePresence> */}
      <div className="z-10 flex size-full max-w-[112rem] flex-col items-center justify-center pt-32">
        {children}
      </div>
    </div>
  );
}
